<div class="confirm-user-deletion">
  <h1 class="heading">{{ title }}</h1>
  <p>
    {{ message }}
  </p>

  <div class="confirmation-buttons">
    <button class="button" (click)="deleteAccount()">Confirm</button>
  </div>
</div>
